import { PermissionType, type Role } from '@repo/api-gw-sdk';

import {
  apps,
  sourceAccountId,
  dataClasses,
  environment,
  resourceName,
  resourceType,
  sensitivityAnnotations,
  sourceRegion,
  subnets,
  vpc,
  resourceId,
  cloudProvider,
  resourceGroupName,
  tagKeys,
  tagKeyValues,
} from '@/components/queryBuilder/properties';
import type { PermissionDescriptor } from '@/contexts/permissions';
import type { FilterProperty } from '@/types/advanceFilter';

export const RESTORE_PERMISSIONS = [
  PermissionType.ResourcesRestore,
  PermissionType.FilesRestore,
  PermissionType.DatabasesQuery,
];

export const hasRestorePermission = (role: Pick<Role, 'permissionGrants'>) =>
  role.permissionGrants.some((g) => RESTORE_PERMISSIONS.includes(g.permission));

export const RoleConditionConditionSupportedProperties: FilterProperty[][] = [
  [resourceType, dataClasses, environment, apps],
  [
    cloudProvider,
    sourceAccountId,
    sourceRegion,
    vpc,
    subnets,
    resourceGroupName,
  ],
  [resourceName, resourceId],
  [tagKeys, tagKeyValues],
];

export const getRoleConditionSupportedProperties = ({
  enableSensitivityAnnotations,
}: {
  enableSensitivityAnnotations: boolean;
}): FilterProperty[][] => {
  if (!enableSensitivityAnnotations) {
    return RoleConditionConditionSupportedProperties;
  }

  return [
    [resourceType, dataClasses, environment, apps, sensitivityAnnotations],
    [
      cloudProvider,
      sourceAccountId,
      sourceRegion,
      vpc,
      subnets,
      resourceGroupName,
    ],
    [resourceName, resourceId],
    [tagKeys, tagKeyValues],
  ];
};

export const getAssignedRoleCondition = (
  permission: PermissionDescriptor,
  role: Role
) => {
  if (!permission.allowConditions) {
    return undefined;
  }

  const accessConditionId = role.permissionGrants.find(
    (x) => x.permission === permission.permissionType
  )?.accessConditionId;

  if (accessConditionId) {
    return role.accessConditions?.find((x) => x.id === accessConditionId);
  }
};
